import { createSelector } from 'reselect';
import _ from 'lodash';

import { contactsIncreasingAlphabetical } from 'utils/sort';

import { getCurrentAddresses } from 'redux/modules/shipper-order-new/selectors';
import { getCancellationValues } from 'redux/modules/shipper-order-form/utils';

const getState = (state) => state.shipperOrderForm;

const getShipperUsers = createSelector(getState, (state) => state.shipperUsers);
const getShipperAddresses = createSelector(
  getState,
  getCurrentAddresses,
  (state, currentAddresses) =>
    _.uniqBy([...state.shipperAddresses, ...currentAddresses], 'url').sort(
      contactsIncreasingAlphabetical
    )
);
const isMainLoading = createSelector(getState, (state) => state.mainLoading);
const isSubmiting = createSelector(getState, (state) => state.submiting);
const getUserInfo = createSelector(getState, (state) => state.userInfo);
const getinitialShipperOrder = createSelector(getState, (state) => state.initialShipperOrder);
const getQuote = createSelector(getState, (state) => {
  const quote = state.quote;

  if (quote.ready && quote.pricing_days) {
    const pricingDaysAsArray = Object.keys(quote.pricing_days)
      .filter((day) => quote.pricing_days[day])
      .map((day) => ({ ...quote.pricing_days[day], day: day }));

    const saturdayQuote =
      pricingDaysAsArray.filter(
        (d) => d.extra_prices.findIndex((e) => e.concept === 'DAY_SATURDAY') >= 0
      )[0] || null;

    const sundayQuote =
      pricingDaysAsArray.filter(
        (d) => d.extra_prices.findIndex((e) => e.concept === 'DAY_SUNDAY') >= 0
      )[0] || null;

    const weekdayQuote =
      pricingDaysAsArray.filter(
        (d) =>
          d.extra_prices.findIndex((e) => ['DAY_SATURDAY', 'DAY_SUNDAY'].includes(e.concept)) < 0
      )[0] || null;

    return {
      ...quote,
      recurring_order_quotes: [
        (!!weekdayQuote && { ...weekdayQuote, day_type: 'weekdays' }) || null,
        (!!saturdayQuote && { ...saturdayQuote, day_type: 'saturdays' }) || null,
        (!!sundayQuote && { ...sundayQuote, day_type: 'sundays' }) || null,
      ].filter((quote) => quote),
    };
  }

  return quote;
});

const getCancellationValuesSelector = createSelector(
  getinitialShipperOrder,
  (initialShipperOrder) => getCancellationValues(initialShipperOrder)
);

export {
  getShipperUsers,
  getShipperAddresses,
  isMainLoading,
  isSubmiting,
  getUserInfo,
  getinitialShipperOrder,
  getQuote,
  getCurrentAddresses,
  getCancellationValuesSelector,
};
